import * as fromDatatype from "../../../../models/datatype-library";

export class PickPackQueueSearchDto {
  guids?: any[];
  server_docs_1?: any[];
  server_docs_2?: any[];
  server_docs_3?: any[];
  server_docs_4?: any[];
  server_docs_5?: any[];
  client_docs_1?: any[];
  client_docs_2?: any[];
  client_docs_3?: any[];
  client_docs_4?: any[];
  client_docs_5?: any[];
  guid_branches?: any[];
  guid_stores?: any[];
  guid_entities?: any[];
  sales_entity_hdr_guids?: any[];
  gen_docline_del_branch_guids?: any[];
  gen_docline_del_location_guids?: any[];
  server_doc_locations?: any[];
  date_txn_from?: fromDatatype.TimestampTzDatatypeInterface;
  date_txn_to?: fromDatatype.TimestampTzDatatypeInterface;
  created_date_from?: fromDatatype.TimestampTzDatatypeInterface;
  created_date_to?: fromDatatype.TimestampTzDatatypeInterface;
  updated_date_from?: fromDatatype.TimestampTzDatatypeInterface;
  updated_date_to?: fromDatatype.TimestampTzDatatypeInterface;
  gendoc_line_requested_delivery_date_from?: fromDatatype.TimestampTzDatatypeInterface;
  gendoc_line_requested_delivery_date_to?: fromDatatype.TimestampTzDatatypeInterface; 
  server_doc_type: string;
  marketplace_status?: string;
  track_delivery_sub_status?: string;
}
